var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFwcrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 267.77 40.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 97.14,
    y: 0,
    width: 14.91,
    height: 27.75,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "cls-1",
    d: "M97.14 0h14.91v27.75H97.14V0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-2",
    x: 170.07,
    y: 0,
    width: 14.19,
    height: 27.75,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    className: "cls-1",
    d: "M184.26 0h-14.19v27.75h14.19V0z"
  }))), /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{fill:#fff}.cls-1,.cls-2{fill-rule:evenodd}.cls-2{fill:#4d4d4d}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-fworks-grey"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "cls-2",
    d: "M48.69 1c-5 0-6.79 3.49-6.79 6.76v2h-1a1.37 1.37 0 100 2.74h1v13.8a1.45 1.45 0 102.9 0V12.52H48a1.37 1.37 0 000-2.74h-3.2v-2c0-1.83.67-4 3.89-4a1.35 1.35 0 001.37-1.38A1.36 1.36 0 0048.69 1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "cls-2",
    d: "M60 9.32a6 6 0 00-5 2.36v-.76a1.45 1.45 0 00-2.9 0V26.3a1.45 1.45 0 002.9 0v-8.48c0-3.56 1.88-5.68 5-5.68a1.41 1.41 0 000-2.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "cls-2",
    d: "M70.32 11.92c3 0 4.54 1.69 4.61 5h-9.69c.3-3.24 2.1-5 5.08-5m7.48 5a8.77 8.77 0 00-1.39-4.79 6.91 6.91 0 00-6.09-2.83c-5.11 0-8 3.4-8 9.33 0 6.12 2.91 9.36 8.42 9.36a8.63 8.63 0 006.08-2.19 1.34 1.34 0 00-.85-2.37 1.28 1.28 0 00-.82.27 6.73 6.73 0 01-4.41 1.58c-3.31 0-5.39-2.17-5.48-5.7H76c1.76 0 1.76-1.6 1.76-2.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "cls-2",
    d: "M87.6 17.11c-2.17-.75-4-1.39-4-3s2-2 3.14-2a5.14 5.14 0 014 1.52 1.34 1.34 0 002.3-.93 1.44 1.44 0 00-.31-.86 7.2 7.2 0 00-6-2.52c-3.72 0-6 1.85-6 4.82 0 3.64 3.19 4.72 6 5.67 2.13.72 4 1.34 4 2.9 0 2.13-2.37 2.45-3.78 2.45a6.19 6.19 0 01-4.64-1.79 1.4 1.4 0 00-1-.45 1.34 1.34 0 00-1 2.21 8.73 8.73 0 006.66 2.82c4.18 0 6.68-2 6.68-5.24 0-3.52-3.15-4.6-5.92-5.56"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)",
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "cls-2",
    d: "M104.84 9.25a6.07 6.07 0 00-4.8 2.07V1.45a1.45 1.45 0 10-2.9 0V26.3a1.45 1.45 0 002.9 0V17c0-3.37 1.61-5.07 4.8-5.07s4.31 1.39 4.31 4.8v9.57a1.45 1.45 0 002.9 0V16.19c0-4.61-2.43-6.94-7.21-6.94"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "cls-2",
    d: "M136.28 9.47a1.43 1.43 0 00-1.36 1l-4.15 11.84-3.39-11.83a1.45 1.45 0 00-2.73 0l-3.39 11.83-4.15-11.85a1.45 1.45 0 00-2.81.5 1.72 1.72 0 00.13.61L120 26.81a1.41 1.41 0 001.36.94 1.46 1.46 0 001.4-1L126 15.48l3.25 11.23a1.47 1.47 0 001.41 1 1.42 1.42 0 001.34-.91l5.56-15.26a1.61 1.61 0 00.13-.62 1.43 1.43 0 00-1.45-1.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    className: "cls-2",
    d: "M146.85 25.27c-3.53 0-5.25-2.19-5.25-6.7s1.77-6.65 5.25-6.65 5.26 2.24 5.26 6.65-1.72 6.7-5.26 6.7m0-16c-5.28 0-8.19 3.32-8.19 9.33s2.91 9.37 8.19 9.37 8.2-3.32 8.2-9.37-2.91-9.33-8.2-9.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    className: "cls-2",
    d: "M166.29 9.32a6 6 0 00-5 2.36v-.76a1.45 1.45 0 10-2.9 0V26.3a1.45 1.45 0 102.9 0v-8.48c0-3.56 1.88-5.68 5-5.68a1.41 1.41 0 000-2.82"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2-2)",
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    className: "cls-2",
    d: "M177.34 16.91l6-4.82a1.45 1.45 0 00.58-1.17 1.47 1.47 0 00-2.43-1.09l-8.55 7V1.45a1.45 1.45 0 10-2.9 0V26.3a1.45 1.45 0 102.9 0v-6l2-1.64 6.56 8.41a1.55 1.55 0 001.25.65 1.43 1.43 0 001.45-1.45 1.34 1.34 0 00-.32-.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    className: "cls-2",
    d: "M193.75 17.11c-2.17-.75-4-1.39-4-3s2-2 3.14-2a5.14 5.14 0 014 1.52 1.34 1.34 0 002.3-.93 1.44 1.44 0 00-.31-.86 7.22 7.22 0 00-6-2.52c-3.72 0-6 1.85-6 4.82 0 3.64 3.19 4.72 6 5.67 2.12.72 4 1.34 4 2.9 0 2.13-2.37 2.45-3.78 2.45a6.23 6.23 0 01-4.65-1.79 1.39 1.39 0 00-1-.45 1.34 1.34 0 00-1.45 1.3 1.39 1.39 0 00.31.87 8.77 8.77 0 006.69 2.82c4.18 0 6.68-2 6.68-5.24 0-3.52-3.15-4.6-5.93-5.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.05 40.18a17 17 0 01-17-17H0a17.05 17.05 0 0117.05-17h12.79a4.27 4.27 0 014.26 4.27v12.68a17 17 0 01-17.05 17.05z",
    fill: "#ffa800"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 17.03,
    cy: 29.1,
    r: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M17 14.9A8.08 8.08 0 009 23a8 8 0 003 6.27v-.17a5 5 0 011.78-3.8A3.92 3.92 0 0113 23a4 4 0 117.24 2.33A5 5 0 0122 29.1v.17a8 8 0 00-5-14.37z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.84 8.16a6.7 6.7 0 015.3 2.55 1.07 1.07 0 00.9.45 1.1 1.1 0 001.12-1.11 1.25 1.25 0 00-.24-.73A8.66 8.66 0 00219.84 6c-6.32 0-9.8 3.91-9.8 11 0 7.29 3.3 11 9.8 11a8.83 8.83 0 007.16-3.37 1.06 1.06 0 00.21-.66 1.12 1.12 0 00-2-.66 6.34 6.34 0 01-5.29 2.49c-5 0-7.38-2.8-7.38-8.81-.08-5.86 2.4-8.83 7.3-8.83zM239.3 18.5a5.85 5.85 0 005.43-6 5.91 5.91 0 00-6-6.05h-6.17a1.17 1.17 0 00-1.18 1.18v19a1.18 1.18 0 002.36 0v-8.12h2.94l6.25 8.72a1.18 1.18 0 001 .55 1.16 1.16 0 001.17-1.18 1.1 1.1 0 00-.24-.72zm3-6a3.66 3.66 0 01-3.59 3.87h-5.01V8.59h5a3.66 3.66 0 013.64 3.88zm24.32-6.33a1.15 1.15 0 00-1 .65l-7.42 13.85-7.4-13.84a1.14 1.14 0 00-1-.66 1.17 1.17 0 00-1.15 1.15v19.32a1.15 1.15 0 002.3 0V11.88l6.24 11.62a1.19 1.19 0 001.05.66 1.17 1.17 0 001-.66l6.27-11.62v14.76a1.15 1.15 0 002.3 0V7.32a1.17 1.17 0 00-1.19-1.15z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFwcrm);
export default __webpack_public_path__ + "static/media/fwcrm.3d83d3c28e705bec72f1b4e46393fb48.svg";
export { ForwardRef as ReactComponent };